<div class="header">
    <p>Most trending prompts ({{totalRecords}})</p>
    <img src="/assets/icons/Close.svg" alt="close" (click)="closeDialog()" />
</div>
<mat-divider></mat-divider>
<div class="tables-grid most-trending-prompts-container">
    <mat-card class="data-table-card">
        <div style="display: flex; align-items: center; padding: 0px 16px; gap: 12px;">
            <div class="position-relative search-input-box">
                <input type="text" placeholder="Search" class="p-8 search-input" style="width: 94%; font-size: 14px;" [(ngModel)]="searchtextData" (ngModelChange)="onSearchChange()" #searchInput>
                <div class="position-absolute search-icon cursor-pointer">
                    <div class="d-flex align-items-center" style="gap: 8px;">
                        <img src="/assets/admin-images/search_cancel_icon.png" style="height: 20px;" alt="search" (click)="clearSearch()" *ngIf="searchtextData">
                        <span style="color: #E1E1EA;" *ngIf="searchtextData">|</span>
                        <img src="/assets/icons/Group 57082.svg" alt="search" (click)="searchData(searchtextData)">
                    </div>
                </div>
            </div>
            <div class="pagination-container">
                
                <mat-paginator #paginator
                    [length]="totalRecords"
                    [pageSize]="pageSize"
                    [pageIndex]="pageIndex"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="onPageChange($event)">
                </mat-paginator>
                
                <div class="page-dropdown">
                    <mat-select [(ngModel)]="pageIndex" (selectionChange)="onPageChangeFromDropdown($event)">
                        <mat-option *ngFor="let page of pageNumbers" [value]="page" style="font-family: lato, sans-serif;">{{ page + 1 }}</mat-option>
                    </mat-select>
                </div>
            </div>
        </div>

        <table mat-table [dataSource]="dataSource" *ngIf="mostTrendingPromptsData?.length > 0" aria-label="most trending prompts">
            <ng-container matColumnDef="rank">
                <th mat-header-cell *matHeaderCellDef style="width: 10%;">Place</th>
                <td mat-cell *matCellDef="let row;">
                    <div class="ellipsis-text">{{ row?.rank }}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="prompt_name">
                <th mat-header-cell *matHeaderCellDef style="width: 30%;">Prompt Title</th>
                <td mat-cell *matCellDef="let row">
                    <div class="ellipsis-text" title="{{ row?.prompt_name }}">{{ row?.prompt_name }}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="usage">
                <th mat-header-cell *matHeaderCellDef style="position: relative; width: 20%;">Usage <span style="font-size: 12px; font-weight: 400; margin-right: 10px;">(Runs)</span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_filled_arrow.svg" alt="up_filled_arrow" (click)="sortingByAsc('usage')" *ngIf="usageAscSort"/></span> 
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_filled_arrow.svg" alt="down_filled_arrow" (click)="sortingByDes('usage')" *ngIf="usageDesSort"/></span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_sort_arrow.svg" alt="up_filled_arrow" *ngIf="!usageAscSort"/></span> 
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_sort_arrow.svg" alt="down_sort_arrow" *ngIf="!usageDesSort"/></span></th>
                <td mat-cell *matCellDef="let row">{{ row?.usage }}</td>
            </ng-container>
            <ng-container matColumnDef="consumers">
                <th mat-header-cell *matHeaderCellDef style="width: 20%;">Users</th>
                <td mat-cell *matCellDef="let row">{{ row?.consumers }}</td>
            </ng-container>
            <ng-container matColumnDef="average_rating">
                <th mat-header-cell *matHeaderCellDef style="width: 20%;">Quality Rating</th>
                <td mat-cell *matCellDef="let row">
                    <div style="display: flex; align-items: center; gap: 4px;">
                        <img src="assets/gamification-images/star_half.svg" alt="half star" /> {{ row?.average_rating }}
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </table>
        <div *ngIf="mostTrendingPromptsData?.length <= 0" style="margin: 70px; font-size: 24px; font-weight: 700; text-align: center;">
            No records found.
        </div>
    </mat-card>
</div>

<div style="display: flex;justify-content: center;">
    @if(isLoading){
         <mat-spinner  diameter="40"></mat-spinner>
        }
</div>